import React from "react";
import "./OpenBets.css";
import Header from "../header/Header";
import Footer from "../Footer/Footer";
import { CiSearch } from "react-icons/ci";
import 'bootstrap/dist/css/bootstrap.min.css';
import { getAllBets } from '../../redux/slice/openBet/openBetSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import Appconfig from '../../config/config';
import axios from 'axios';
import Helper from "../../helper";
import { useNavigate } from 'react-router-dom';
import { Table } from "antd";
import ExposureHeader from '../ExposureHeader/ExposureHeader';
import ScrollGames from "../ScrollGames/ScrollGames";

function OpenBets() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = Helper();
  const openbets = useSelector((state) => state.bets);
  const [fancyBets, setFancyBets] = useState([]);
  const [matchBets, setMatchBets] = useState([]);
  const allBets = [...matchBets, ...fancyBets];

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredBets, setFilteredBets] = useState([]);

  // This state correctly controls whether the table appears at all.
  const [isTableVisible, setIsTableVisible] = useState(false);

  const getOpenBetsByEvent = async () => {
    dispatch(getAllBets({
      user_id: userInfo?._id,
    }))
  }

  useEffect(() => {
    getOpenBetsByEvent()
  }, [])

  useEffect(() => {
    if (openbets?.bets?.length > 0) {
      let openBetsData = openbets?.bets;
      let fancyOpenBets = openBetsData?.filter(fancy => fancy.betting_type === "Fancy");
      let matchOpenBets = openBetsData?.filter(match => match.betting_type === "Match");
      setFancyBets(fancyOpenBets);
      setMatchBets(matchOpenBets);
    } else {
      setFancyBets([]);
      setMatchBets([]);
    }
  }, [openbets])

  const handleSubmit = (e) => {
    e.preventDefault();
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      to.setHours(23, 59, 59, 999);

      // The filtering logic based on 'createdAt' (place time) is correct.
      const filtered = allBets.filter(bet => {
        const betDate = new Date(bet.createdAt);
        return betDate >= from && betDate <= to && !bet.is_settled;
      });

      setFilteredBets(filtered);

      // KEY STEP: This makes the table visible after submission, even if 'filtered' is an empty array.
      setIsTableVisible(true);
    }
  };

  const handleReset = () => {
    setFromDate("");
    setToDate("");
    setFilteredBets([]);

    // This correctly hides the table on reset.
    setIsTableVisible(false);
  };

  return (
    <>
      <div className="open-bet lg:pl-[18rem]">
        <div className="w-full mt-2">
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
              <input
                type="date"
                value={fromDate}
                onChange={e => setFromDate(e.target.value)}
                className="d-and-t border rounded px-2 py-1 text-black w-full md:w-auto"
                required
              />
              <input
                type="date"
                value={toDate}
                onChange={e => setToDate(e.target.value)}
                className="d-and-t border rounded px-2 py-1 text-black w-full md:w-auto"
                required
              />
              <input
                type="submit"
                value="Submit"
                className="btn-submit px-4 py-1 rounded bg-blue-500 text-white w-full md:w-auto"
              />
              <input
                type="button"
                value="Reset"
                className="btn-submit px-4 py-1 rounded bg-gray-300 text-black w-full md:w-auto"
                onClick={handleReset}
              />
            </div>
          </form>
        </div>

        {/* This condition ensures the entire table structure renders only after form submission. */}
        {isTableVisible && (
          <div className="overflow-x-auto mt-4">
            <table className="min-w-full border border-gray-300 rounded-lg">
              <thead className="bg-[#028DAD] text-white">
                <tr>
                  <th className="px-2 py-2 border">Event Name</th>
                  <th className="px-2 py-2 border">Market Type</th>
                  <th className="px-2 py-2 border">Selection</th>
                  <th className="px-2 py-2 border">Bet Type</th>
                  <th className="px-2 py-2 border">Stack</th>
                  <th className="px-2 py-2 border">Odds</th>
                  <th className="px-2 py-2 border">Round ID</th>
                  <th className="px-2 py-2 border">Place Time</th>
                  <th className="px-2 py-2 border">Type</th>
                </tr>
              </thead>
              <tbody>
                {/* This condition handles the two cases: data found or no data found. */}
                {filteredBets.length > 0 ? (
                  filteredBets.map((record, idx) => (
                    <tr
                      key={record._id || idx}
                      className={record?.is_back ? 'bg-[#72BBEF] text-black' : 'bg-[#F9C9D4] text-black'}
                    >
                      <td className="px-2 py-2 border">{record?.event_name}</td>
                      <td className="px-2 py-2 border">{record?.market_name}</td>
                      <td className="px-2 py-2 border">{record?.runner_name}</td>
                      <td className="px-2 py-2 border">{record?.is_back ? 'Back' : 'Lay'}</td>
                      <td className="px-2 py-2 border">{record?.stake}</td>
                      <td className="px-2 py-2 border">{record?.price_val}</td>
                      <td className="px-2 py-2 border">{record?._id}</td>
                      <td className="px-2 py-2 border">
                        {new Date(record?.createdAt).toLocaleString("en-GB")}
                      </td>
                      <td className="px-2 py-2 border">
                        {record?.betting_type === "Fancy" ? "Session" : "Match Odds"}
                      </td>
                    </tr>
                  ))
                ) : (
                  // This part is correctly shown if the table is visible but there are no results.
                  <tr>
                    <td colSpan={9} className="text-center py-4 text-black">
                      No Open Bets Found for the Selected Dates
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <br />
      <br />
    </>
  );
}

export default OpenBets;
// import React from "react";
// import "./OpenBets.css"; // Include the CSS in a separate file or use inline styles
// // import "../../../src/App.css";
// import Header from "../header/Header";
// import Footer from "../Footer/Footer";
// import { CiSearch } from "react-icons/ci";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { getAllBets } from '../../redux/slice/openBet/openBetSlice';
// import { useSelector, useDispatch } from 'react-redux';
// import { useEffect, useState } from 'react';
// import Appconfig from '../../config/config';
// import axios from 'axios';
// import Helper from "../../helper";
// import { useNavigate } from 'react-router-dom';
// import { Table } from "antd";
// import ExposureHeader from '../ExposureHeader/ExposureHeader';
// import ScrollGames from "../ScrollGames/ScrollGames";


// function OpenBets() {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const userInfo = Helper(); // get login user details
//   const openbets = useSelector((state) => state.bets); // Use selector to access state
//   const [fancyBets, setFancyBets] = useState([]);
//   const [matchBets, setMatchBets] = useState([]);
//   const [eventType, setEventType] = useState(undefined);

//   // const [matchBets, setMatchBets] = useState([]);

//   // console.log('matchBets', matchBets);
//   // console.log('fancyBets', fancyBets);

//   const getOpenBetsByEvent = async () => {
//     dispatch(getAllBets({
//       user_id: userInfo?._id,
//     }))
//   }

//   useEffect(() => {
//     getOpenBetsByEvent()
//   }, [])

//   useEffect(() => {
//     if (openbets?.bets?.length > 0) {
//       let openBetsData = openbets?.bets;
//       let fancyOpenBets = openBetsData?.filter(fancy => fancy.betting_type == "Fancy");
//       let matchOpenBets = openBetsData?.filter(match => match.betting_type == "Match");
//       setFancyBets(fancyOpenBets);
//       setMatchBets(matchOpenBets);
//     }
//   }, [openbets])

//   console.log("openbets:", openbets);


//   const columns = [
//     {
//       title: 'Event Name',
//       dataIndex: 'event_name',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?.event_name}</span>
//         </>
//       ),
//     },
//     {
//       title: 'Market Type',
//       dataIndex: 'market_name',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?.market_name}</span>
//         </>
//       ),
//     },
//     {
//       title: 'Selection',
//       dataIndex: 'runner_name',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?.runner_name}</span>
//         </>
//       ),
//     },
//     {
//       title: 'Bet Type',
//       dataIndex: 'is_back',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?.is_back ? 'Back' : 'Lay'}</span>
//         </>
//       ),
//     },
//     {
//       title: 'Stack',
//       dataIndex: 'stake',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?.stake}</span>
//         </>
//       ),
//     },

//     {
//       title: 'odds',
//       dataindex: 'price_val',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?.price_val}</span>
//         </>
//       ),
//     },

//     {
//       title: 'Round ID',
//       dataIndex: 'betting_id',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?._id}</span>
//         </>
//       ),
//     },
//     {
//       title: 'Place Time',
//       dataIndex: 'createdAt',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>
//             {new Date(record?.createdAt).toLocaleString("en-GB", {
//               day: "2-digit",
//               month: "2-digit",
//               year: "numeric",
//               hour: "2-digit",
//               minute: "2-digit",
//               second: "2-digit",
//               hour12: true,
//             })}
//           </span>
//         </>
//       ),
//     },
//   ];


//   const columnFancy = [
//     {
//       title: 'Event Name',
//       dataIndex: 'name',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?.event_name}</span>
//         </>
//       ),
//       width: '20%',
//     },
//     {
//       title: 'Market Type',
//       dataIndex: 'name',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?.market_name}</span>
//         </>
//       ),
//       width: '20%',
//     },
//     {
//       title: 'Selection',
//       dataIndex: 'name',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?.runner_name}</span>
//         </>
//       ),
//       width: '20%',
//     },
//     {
//       title: 'Bet Type',
//       dataIndex: 'name',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?.is_back ? 'Back' : 'Lay'}</span>
//         </>
//       ),
//       width: '20%',
//     },
//     {
//       title: 'Stack',
//       dataIndex: 'name',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?.stake}</span>
//         </>
//       ),
//       width: '20%',
//     },
//     {
//       title: 'odds',
//       dataindex: 'price_val',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?.price_val}</span>
//         </>
//       ),
//       width: '20%',

//     },


//     {
//       title: 'Round ID',
//       dataIndex: 'name',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>{record?._id}</span>
//         </>
//       ),
//       width: '20%',
//     },
//     {
//       title: 'Place Time',
//       dataIndex: 'name',
//       sorter: true,
//       render: (_, record) => (
//         <>
//           <span>
//             {new Date(record?.createdAt).toLocaleString("en-GB", {
//               day: "2-digit",
//               month: "2-digit",
//               year: "numeric",
//               hour: "2-digit",
//               minute: "2-digit",
//               second: "2-digit",
//               hour12: true,
//             })}
//           </span>
//         </>
//       ),
//       width: '20%',
//     },
//   ];


//   return (
//     <>
//       {/* <ScrollGames eventType={eventType} setEventType={setEventType} /> */}

//       {/* <Header /> */}
//       {/* <ExposureHeader /> */}

//       <div className="open-bet lg:pl-[18rem]">
//         <p className="open-para">
//           <span>Open Bets</span>
//         </p>
//         <p className="odds">
//           <span>Match Odds</span>
//         </p>
//         <div className="table-container">
//           <Table
//             columns={columns}
//             dataSource={matchBets}
//             pagination={true}
//             bordered={true}
//           />
//         </div>

//         <p className="odds">
//           <span>Session</span>
//         </p>

//         <div className="table-container">
//           <Table
//             columns={columnFancy}
//             dataSource={fancyBets}
//             pagination={true}
//             bordered={true}
//           />
//         </div>
//       </div>
//       <br />
//       <br />
//       {/* <Footer /> */}
//     </>
//   );
// }

// export default OpenBets;
// "use client"
// import "./OpenBets.css" // Include the CSS in a separate file or use inline styles
// import "bootstrap/dist/css/bootstrap.min.css"
// import { getAllBets } from "../../redux/slice/openBet/openBetSlice"
// import { useSelector, useDispatch } from "react-redux"
// import { useEffect, useState } from "react"
// import Helper from "../../helper"
// import { useNavigate } from "react-router-dom"
// import ScrollGames from "../ScrollGames/ScrollGames"

// function OpenBets() {
//   const navigate = useNavigate()
//   const dispatch = useDispatch()
//   const userInfo = Helper() // get login user details
//   const openbets = useSelector((state) => state.bets) // Use selector to access state
//   const [fancyBets, setFancyBets] = useState([])
//   const [matchBets, setMatchBets] = useState([])
//   const [allBets, setAllBets] = useState([])

//   // Pagination states
//   const [matchCurrentPage, setMatchCurrentPage] = useState(1)
//   const [fancyCurrentPage, setFancyCurrentPage] = useState(1)
//   const [allBetsCurrentPage, setAllBetsCurrentPage] = useState(1)
//   const itemsPerPage = 10

//   const getOpenBetsByEvent = async () => {
//     dispatch(
//       getAllBets({
//         user_id: userInfo?._id,
//       }),
//     )
//   }

//   useEffect(() => {
//     getOpenBetsByEvent()
//   }, [])

//   useEffect(() => {
//     if (openbets?.bets?.length > 0) {
//       const openBetsData = openbets?.bets
//       const fancyOpenBets = openBetsData?.filter((fancy) => fancy.betting_type == "Fancy")
//       const matchOpenBets = openBetsData?.filter((match) => match.betting_type == "Match")
//       setFancyBets(fancyOpenBets)
//       setMatchBets(matchOpenBets)

//       // Combine all bets into one array
//       const combinedBets = [...matchOpenBets, ...fancyOpenBets]
//       setAllBets(combinedBets)
//     }
//   }, [openbets])

//   console.log("openbets:", openbets)

//   // Pagination logic
//   const getPaginatedData = (data, currentPage) => {
//     const startIndex = (currentPage - 1) * itemsPerPage
//     const endIndex = startIndex + itemsPerPage
//     return data.slice(startIndex, endIndex)
//   }

//   const getTotalPages = (data) => {
//     return Math.ceil(data.length / itemsPerPage)
//   }

//   const renderPagination = (data, currentPage, setCurrentPage) => {
//     const totalPages = getTotalPages(data)
//     if (totalPages <= 1) return null

//     const pages = []
//     for (let i = 1; i <= totalPages; i++) {
//       pages.push(i)
//     }

//     return (
//       <div className="flex justify-center items-center space-x-2 mt-4">
//         <button
//           onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
//           disabled={currentPage === 1}
//           className="px-3 py-1 border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
//         >
//           Previous
//         </button>

//         {pages.map((page) => (
//           <button
//             key={page}
//             onClick={() => setCurrentPage(page)}
//             className={`px-3 py-1 border rounded-md ${currentPage === page ? "bg-blue-500 text-white border-blue-500" : "border-gray-300 hover:bg-gray-50"
//               }`}
//           >
//             {page}
//           </button>
//         ))}

//         <button
//           onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
//           disabled={currentPage === totalPages}
//           className="px-3 py-1 border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
//         >
//           Next
//         </button>
//       </div>
//     )
//   }

//   const CustomTable = ({ data, currentPage, setCurrentPage, title }) => {
//     const paginatedData = getPaginatedData(data, currentPage)

//     return (
//       <div className="mb-8">
//         <p className="text-lg font-semibold mb-4 text-gray-800">
//           <span>{title}</span>
//         </p>

//         <div className="overflow-x-auto shadow-lg rounded-lg border border-gray-200">
//           <table className="min-w-full bg-white">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
//                   Event Name
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
//                   Type
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
//                   Stack
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">
//                   Odds
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {paginatedData.length > 0 ? (
//                 paginatedData.map((record, index) => (
//                   <tr key={record._id || index} className="hover:bg-gray-50 transition-colors duration-200">
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b border-gray-100">
//                       {record?.event_name}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm border-b border-gray-100">
//                       <span
//                         className={`px-2 py-1 text-xs font-medium rounded-full ${record?.betting_type === "Match" ? "bg-blue-100 text-blue-800" : "bg-green-100 text-green-800"
//                           }`}
//                       >
//                         {record?.betting_type === "Match" ? "Match" : "Fancy"}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b border-gray-100">
//                       {record?.stake}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b border-gray-100">
//                       {record?.price_val}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="4" className="px-6 py-8 text-center text-gray-500">
//                     No data available
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {renderPagination(data, currentPage, setCurrentPage)}
//       </div>
//     )
//   }

//   return (
//     <>
//       <ScrollGames />
//       {/* <Header /> */}
//       {/* <ExposureHeader /> */}
//       <div className="open-bet p-6 bg-gray-50 min-h-screen">
//         <div className="max-w-7xl mx-auto">
//           <p className="text-2xl font-bold mb-6 text-gray-800">
//             <span>Open Bets</span>
//           </p>

//           <CustomTable
//             data={allBets}
//             currentPage={allBetsCurrentPage}
//             setCurrentPage={setAllBetsCurrentPage}
//             title="All Bets (Match & Fancy)"
//           />
//         </div>
//       </div>
//       <br />
//       <br />
//       {/* <Footer /> */}
//     </>
//   )
// }

// export default OpenBets
